'use client';
/** @jsxImportSource @emotion/react */

import { type SVGProps } from 'react';
const SvgArrowDropdown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height={24}
    viewBox="0 0 24 24"
    width={24}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="m7 10 5 5 5-5H7Z" fill="currentColor" />
  </svg>
);
export default SvgArrowDropdown;
